import { flow, types } from 'mobx-state-tree'
import { addEssControlFlagMid } from '../../network/addEssControlFlagMid'
import { getAllMids } from '../../network/getAllMids'
import { getErrorMessage, MessageTypes } from '../../utils'
import { RootStore } from '../store'

const EssControls = types
  .model('EssControls', {
    id: types.maybeNull(types.number),
    ctpmFlag: types.optional(types.string, ''),
    mids: types.array(types.string),
  })
  .actions((self) => ({
    fetchAllMids: flow(function* fetchAllMids() {
      try {
        const response = yield getAllMids(RootStore.session.getTokens)
        self.ctpmFlag = response.settlementFlag
        self.mids = response.mids
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    addMids: flow(function* addMids(flag: string, mids: any) {
      try {
        if (flag === 'ESS_MID_SPECIFIC' || flag === 'ESS_MID_SPECIFIC_AND_MAS_ONLY_PAYOUT') {
          if (mids?.length > 0) {
            const midList = mids?.map((item) => item.id)
            const response = yield addEssControlFlagMid(RootStore.session.getTokens, flag, midList)
            RootStore.message.setMessage('Success', MessageTypes.SUCCESS)
            return response
          } else {
            RootStore.message.setMessage('No Data to update', MessageTypes.ERROR)
          }
        } else {
          const response = yield addEssControlFlagMid(RootStore.session.getTokens, flag, mids)
          RootStore.message.setMessage('Success', MessageTypes.SUCCESS)
          return response
        }
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))
  .views((self) => ({
    getAllMids(flag: string) {
      if (self.ctpmFlag === flag) {
        return self?.mids?.map((item: any) => {
          return { id: item, actionDownload: ',DELETE' }
        })
      } else {
        return []
      }
    },
  }))

const essControlsData = {}
export { EssControls, essControlsData }
